var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(this.$route.meta && this.$route.meta.loadable)?[(_vm.$wait.is(_vm.event))?void 0:[_vm._t("default")]]:[_vm._t("default")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }